<script>
import {defineComponent} from 'vue'
import HeadNav from "../components/headNav.vue";
import {getProvision} from "../api/api";

export default defineComponent({
  name: "blog",
  components: {HeadNav},
  data(){
    return{
      page:1,
      dataList:[],
      obj:{}
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      getProvision({
        id:2
      }).then(res => {
        console.log(res,'打印res')
        this.obj = res.data.data
      })
    }
  }
})
</script>

<template>
  <div style="background-color: #f1f1f1">
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid style="margin-bottom: 30px;margin-top: 30px">
      <b-row>
        <b-col sm="9">
          <div style="font-weight: 600;font-size: 26px;margin-bottom: 30px
">
            Provision
          </div>
          <div style="" class="module">
            <div style="margin-bottom: 20px;font-size: 20px;font-weight: 600">{{obj.title}}</div>
            <div v-html="obj.details"></div>
          </div>
        </b-col>
        <b-col sm="3">
          <div class="rightBox">

          </div>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
.module{
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  background-color: #FFFFFF;
}
.rightBox{
  border-radius: 10px;
  margin-top: 80px;
  background-color: #FFFFFF;
  height: 800px;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
}
</style>



// WEBPACK FOOTER //
// src/view/problem.vue